import type { ServiceHighlightsSection } from "@/data/types";
import { resolveImagePath } from "@/utils/imageMap";

interface ServiceHighlightsProps {
  data: ServiceHighlightsSection;
}

export function ServiceHighlights({ data }: ServiceHighlightsProps) {
  return (
    <section className="py-0">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[400px]">
        {data.highlights.map((highlight, index) => (
          <div
            key={index}
            className="relative overflow-hidden group"
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${resolveImagePath(highlight.backgroundImage)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="relative z-10 p-8 md:p-12 flex flex-col justify-center text-center text-white min-h-[400px]">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight">
                {highlight.title}
              </h2>
              
              <p className="text-base md:text-lg mb-8 max-w-md mx-auto leading-relaxed opacity-90">
                {highlight.description}
              </p>
              
              {highlight.ctaButton && (
                <div className="flex justify-center">
                  <a
                    href={highlight.ctaButton.href}
                    className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-300 shadow-lg hover:shadow-xl"
                  >
                    {highlight.ctaButton.text}
                  </a>
                </div>
              )}
            </div>
            
            {/* Overlay for hover effect */}
            <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none" />
          </div>
        ))}
      </div>
    </section>
  );
}